import React from 'react'
import '../assets/fonts/fonts.css'
import education from '../assets/icons/education.png'
import working from '../assets/icons/working.png'
import hobies from '../assets/icons/hobies.png'
import AboutImg from '../assets/profile/aboutImg.jpeg'

const About = () => {
    return (
        <div className='h-full p-4 pt-16 bg-gray-800' id='about'>
            <div className="text-center text-white subheadings-font text-4xl font-bold">
                About
            </div>
            <div className="flex justify-around my-8">
                <div className="flex justify-center items-center about-style">
                    <img src={AboutImg} alt="profileimage" width={150} height={150} className='rounded-md' />
                    <div className="text-left font-normal subheadings-font-text-2xl text-white mx-2">
                        Hey there 👋, I am Sai Charan a 2nd year Student at IIIT Manipur pursuing Btech in Computer Science and Engineering. I am interested in Web Technology and work mainly on the MERN stack. I also have industrial experience in the relevant field, in the past I worked with one startup and currently working with the other startup. <br />
                        I am currently exploring Web3 🌐 <br />
                        Thanks for visiting!!
                    </div>
                </div>
            </div>
            <div className='flex justify-around flex-wrap'>
                <div className='mt-8 flex flex-col'>
                    <div>
                        <h2 className=" text-purple-300 text-3xl font-bold subheadings-font flex">
                            <img src={education} alt="📚" className='h-8 mr-2' />
                            Education
                        </h2>
                        <div className='ml-3 md:ml-12 mt-5 subheadings-font'>
                            <p className='text-lg md:text-2xl text-white font-medium'>➡ IIIT Manipur</p>
                            <p className='ml-8 text-base md:text-xl font-nexaBold' style={{ color: 'gray' }}>Bachelor in technology in CSE (2020-2024) 8.11 CPI.</p>
                        </div>
                        <div className='ml-3 md:ml-12 mt-5 subheadings-font'>
                            <p className='text-lg md:text-2xl text-white font-medium'>➡ Narayana junior collage</p>
                            <p className='ml-8 text-base md:text-xl font-nexaBold' style={{ color: 'gray' }}>12th board CBSE (2018-2020) scored 93.2%.</p>
                        </div>
                        <div className='ml-3 md:ml-12 mt-5 subheadings-font'>
                            <p className='text-lg md:text-2xl text-white font-medium'>➡ Sri prakash vidyaniketan</p>
                            <p className='ml-8 text-base md:text-xl font-nexaBold' style={{ color: 'gray' }}>10th board CBSE (2016-2018) scored 89.6%.</p>
                        </div>
                    </div>
                    <div className='mt-8'>
                        <h2 className=" text-purple-300 text-3xl font-bold subheadings-font flex">
                            <img src={hobies} alt="(❁´◡`❁)" className='h-8 mr-2 relative bottom-2' />
                            Hobbies
                        </h2>
                        <div className='ml-3 md:ml-12 mt-5 subheadings-font'>
                            <p className='text-lg md:text-2xl text-white font-medium'>➡ Reading books.</p>
                            <p className='text-lg md:text-2xl text-white font-medium'>➡ Watching anime.</p>
                            <p className='text-lg md:text-2xl text-white font-medium'>➡ Learning about new things.</p>
                        </div>
                    </div>
                </div>
                <div className='mt-8'>
                    <h2 className=" text-purple-300 text-3xl font-bold subheadings-font flex">
                        <img src={working} alt="💻" className='h-8 mr-2' />
                        Work Experience
                    </h2>
                    <div className='ml-3 md:ml-12 mt-5 subheadings-font text-white  font-medium'>
                        <p className='text-lg md:text-2xl -mb-1 mt-2'>➡ Software Developer Intern at Artyvis.</p>
                        <p className='ml-8 text-base md:text-xl font-nexaBold mb-2' style={{ color: 'gray' }}>From: May 2022 - Present.</p>
                        <p className='text-lg md:text-2xl -mb-1 mt-2'>➡ Software Developer (React) Intern at Infokriti.</p>
                        <p className='ml-8 text-base md:text-xl font-nexaBold mb-2' style={{ color: 'gray' }}>From: July 2021 - Oct 2021.</p>
                        <p className='text-lg md:text-2xl -mb-1 mt-2'>➡ Sales Consultant Intern at GeeksforGeeks.</p>
                        <p className='ml-8 text-base md:text-xl font-nexaBold mb-2' style={{ color: 'gray' }}>From: September 2021 - Nov 2021.</p>
                        <p className='text-lg md:text-2xl -mb-1 mt-2'>➡ Campus Ambassador at GeeksforGeeks.</p>
                        <p className='ml-8 text-base md:text-xl font-nexaBold' style={{ color: 'gray' }}>From: June 2021 - April 2022.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About
